import React, { Component } from 'react';
import './textField.css';

import {ReactComponent as EyeOpenIcon} from '../../../../images/ui/eyeOpen.svg';
import {ReactComponent as EyeCloseIcon} from '../../../../images/ui/eyeClose.svg';

class TextField extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isFocused: false,

            type: props.type,
            eyeIsOpen: false,
        };

        this.inputRef = React.createRef();
        this.containerRef = React.createRef();

        this.handleFocus = this.handleFocus.bind(this);
        this.handleBlur = this.handleBlur.bind(this);
        this.handleContainerClick = this.handleContainerClick.bind(this);
    }

    handleFocus() {
        this.setState({isFocused: true});
    }

    handleBlur() {
        const {value} = this.props;
        this.setState({isFocused: value !== ''});
    }

    handleContainerClick() {
        if (this.inputRef.current) {
            this.inputRef.current.focus();
        }
    }

    preventScroll = (event) => {
        if (this.inputRef.current && this.inputRef.current.type === 'number') {
            event.preventDefault();
        }
    };

    componentDidMount() {
        if (this.inputRef.current && this.inputRef.current.type === 'number') {
            this.inputRef.current.addEventListener('wheel', this.preventScroll);
        }
    }

    componentWillUnmount() {
        if (this.inputRef.current && this.inputRef.current.type === 'number') {
            this.inputRef.current.removeEventListener('wheel', this.preventScroll);
        }
    }

    render() {
        const {
            customClass,
            label,
            value,
            onChange,
            placeholder = '',
            fullWidth,
            type = 'text',
            multiline = false,
            formStatus = undefined,
            formDescription = '',
            ...props
        } = this.props;

        const classList = ['text-field-component']

        if (document.activeElement === this.inputRef.current) classList.push('focused')
        if (value) classList.push('filled')
        if (customClass) classList.push(customClass)
        if (fullWidth) classList.push('full-width')

        const rootClassList = ['text-field-root']

        if (fullWidth) rootClassList.push('full-width')
        if (formStatus === true) rootClassList.push('success')
        if (formStatus === false) rootClassList.push('rejected')

        const component = <div
            ref={this.containerRef}
            className={classList.join(' ')}
            onClick={this.handleContainerClick}
        >
            {multiline ? (
                <textarea
                    ref={this.inputRef}
                    value={value !== null ? value || '' : ''}
                    onChange={onChange}
                    onFocus={this.handleFocus}
                    onBlur={this.handleBlur}
                    placeholder={placeholder}
                    {...props}
                />
            ) : (
                <input
                    type={this.state.eyeIsOpen ? 'text' : type}
                    ref={this.inputRef}
                    value={value !== null ? value || '' : ''}
                    onChange={onChange}
                    onFocus={this.handleFocus}
                    onBlur={this.handleBlur}
                    placeholder={placeholder}
                    {...props}
                />
            )}
            <label>{label}</label>
            {this.props.type === 'password' ?
                <div className='eye' onClick={() => this.setState({eyeIsOpen: !this.state.eyeIsOpen})}>
                    {this.state.eyeIsOpen ? <EyeCloseIcon/> : <EyeOpenIcon/>}
                </div> : null}
        </div>

        return (
            formDescription ?
                <div className={rootClassList.join(' ')}>
                    {component}
                    <div className='label'>{formDescription}</div>
                </div> :
                <>{component}</>
        );
    }
}

export default TextField;
